/* global ADV */
import React from 'react';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

const NoClientAccess = () => {
  useDocumentTitle('No Access | Orion Planning');

  return (
    <div className="no-client-access">
      <h2 className="no-client-access-title">Thank you for your patience.</h2>
      <h3 className="no-client-access-subtitle">
        Your information is being reviewed. Please check back for access to your dashboard.
      </h3>

      <img
        className="no-client-access-illustration"
        src={`${ADV.settings.endpoints.imgDir}pig-doctor.png`}
        alt="No Access Illustration"
      />
    </div>
  );
};

export default NoClientAccess;
